import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Global } from '@emotion/react';
import globalStyles from 'styles/GlobalStyles';
import IndexPage from 'pages/index';
import MintPage from 'pages/mint';
import AirdropPage from 'pages/airdrop';
import AnimeTestPage from 'pages/anime-test';
import ParallaxTestPage from 'pages/parallax-test';

declare global {
  interface Window {
    klaytn: any;
    caver: any;
    ethereum: any;
  }
}

function App() {
  return (
    <>
      <Global styles={globalStyles} />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<IndexPage />} />
          <Route path='/mint' element={<MintPage />} />
          <Route path='/airdrop-ldcc' element={<AirdropPage />} />
          <Route path='/anime-test' element={<AnimeTestPage />} />
          <Route path='/parallax-test' element={<ParallaxTestPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
